import {
  tag_colorTagBlueBackground,
  tag_colorTagBlueBackgroundHover,
  tag_colorTagBlueText,
  tag_colorTagBlueTextHover,
  tag_colorTagDefaultBackground,
  tag_colorTagDefaultText,
  tag_colorTagHighlightBackground,
  tag_colorTagHighlightBackgroundHover,
  tag_colorTagHighlightText,
  tag_colorTagHighlightTextHover,
  tag_colorTagNewBackground,
  tag_colorTagNewBackgroundHover,
  tag_colorTagNewText,
  tag_colorTagNewTextHover,
  tag_colorTagPendingBackground,
  tag_colorTagPendingBackgroundHover,
  tag_colorTagPendingTextHover,
  tag_colorTagSevereBackground,
  tag_colorTagSevereBackgroundHover,
  tag_colorTagSevereText,
  tag_colorTagSevereTextHover
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { pill_transitionSpeed } from 'ext-ui/style/transitionSpeeds'
import {
  font_2xl,
  font_family_weight_medium,
  font_md,
  font_size_xs,
  font_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  padding: ${spacing(0.5)} ${spacing(1)};
  width: fit-content;
  border-radius: 5px;
  background-color: ${tag_colorTagDefaultBackground};
  color: ${tag_colorTagDefaultText};
  ${font_sm}
  font-family: ${font_family_weight_medium};
  &.clickable {
    cursor: pointer;
    transition:
      background-color ${pill_transitionSpeed} ease-out,
      color ${pill_transitionSpeed} ease-out;
  }

  /* SIZE VARIANTS */
  &.small {
    padding: 0 ${spacing(1)};
    font-size: ${font_size_xs};
    line-height: 16px;
  }

  /* &.medium is the default. No class needed */

  &.large {
    padding: ${spacing(1)} ${spacing(2)};
    ${font_md}
  }

  &.xlarge {
    padding: ${spacing(1)} ${spacing(2)};
    ${font_2xl}
  }

  /* COLOR VARIANTS */
  &.highlight {
    background-color: ${tag_colorTagHighlightBackground};
    color: ${tag_colorTagHighlightText};
    &.clickable:hover {
      background-color: ${tag_colorTagHighlightBackgroundHover};
      color: ${tag_colorTagHighlightTextHover};
    }
  }

  &.new {
    background-color: ${tag_colorTagNewBackground};
    color: ${tag_colorTagNewText};
    &.clickable:hover {
      background-color: ${tag_colorTagNewBackgroundHover};
      color: ${tag_colorTagNewTextHover};
    }
  }

  &.severe {
    background-color: ${tag_colorTagSevereBackground};
    color: ${tag_colorTagSevereText};
    &.clickable:hover {
      background-color: ${tag_colorTagSevereBackgroundHover};
      color: ${tag_colorTagSevereTextHover};
    }
  }

  &.pending {
    background-color: ${tag_colorTagPendingBackground};
    color: ${tag_colorTagPendingTextHover};
    &.clickable:hover {
      background-color: ${tag_colorTagPendingBackgroundHover};
      color: ${tag_colorTagPendingTextHover};
    }
  }

  &.saas {
    background-color: ${tag_colorTagBlueBackground};
    color: ${tag_colorTagBlueText};
    &.clickable:hover {
      background-color: ${tag_colorTagBlueBackgroundHover};
      color: ${tag_colorTagBlueTextHover};
    }
  }
`
